import { useDrugCalculatorComponentContext } from '../contexts/DrugCalculatorComponentContext';
import Loader from '../components/Loader';
import { useEffect } from 'react';
import { DrugDosageCalculator } from '@gekkovet-oy/shared-components';
import { Alert, Box } from '@mui/material';
import { ComponentsCallback } from '../initComponents';

export const DrugCalculatorComponent = ({
  searchParams,
  sessionId,
}: {
  sessionId: string;
  searchParams: URLSearchParams;
}) => {
  const { session, setSignature, setTimestamp, setSessionId } =
    useDrugCalculatorComponentContext();

  const componentsCallback: ComponentsCallback = (window as any)
    .__componentsCallback;

  useEffect(() => {
    const signature = searchParams.get('signature');
    const timestamp = searchParams.get('timestamp');
    setSignature(signature || 'dummy');
    setTimestamp(timestamp || 'dummy');
  }, [searchParams, setSignature, setTimestamp]);

  useEffect(() => {
    if (!sessionId) return;
    setSessionId(sessionId);
  }, [sessionId, setSessionId]);

  if (!session) {
    return <Loader showLoader={true} />;
  }

  if (!session.data.drug_substance_id) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Missing drug_substance_id in session data
        </Alert>
      </Box>
    );
  }

  return (
    <DrugDosageCalculator
      drugSubstanceId={session.data.drug_substance_id}
      patientWeightKg={session.data.patient_weight}
      onCalculation={(type, values, alt, dose) => {
        componentsCallback('calculationPerformed', {
          type,
          values,
          alt,
          dose,
        });
      }}
    />
  );
};
